import type { ReactNode } from "react";

export function ProfileEmptyState({
    title,
    description,
    actions,
}: {
    title: string;
    description: string;

    actions?: ReactNode;
}) {
    return (
        <div className="flex flex-col items-center gap-4 rounded-card bg-havanese/50 p-card text-center">
            <p className="text-item-title text-doberman-black">{title}</p>
            <p className="max-w-md text-body text-doberman-black/60">
                {description}
            </p>
            {actions && (
                <div className="flex flex-wrap justify-center gap-3">
                    {actions}
                </div>
            )}
        </div>
    );
}
